import { render } from "./Bonus.vue?vue&type=template&id=74659b22&scoped=true"
import script from "./Bonus.vue?vue&type=script&lang=js"
export * from "./Bonus.vue?vue&type=script&lang=js"

import "./Bonus.vue?vue&type=style&index=0&id=74659b22&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-74659b22"

export default script